// extracted by mini-css-extract-plugin
export var messageSideLeft = "_r9-1";
export var stateContainer = "_r9-0";